const getters = {
  jobListFilters(s) {
    return (
      s.jobList || {
        channels: [],
        tags: { contact: [], employer: [], attendance: [] },
        tagVisibility: { attendance: true, contact: true, employer: true },
      }
    );
  },
};

export default getters;
